import { Component } from '@angular/core';
import { membersuitesubledger_entry_batchesEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Subledger Entry Batches') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitesubledger_entry_batches-form',
    templateUrl: './membersuitesubledger_entry_batches.form.component.html'
})
export class membersuitesubledger_entry_batchesFormComponent extends BaseFormComponent {
    public record!: membersuitesubledger_entry_batchesEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

